import { useState } from "react";
import { useSelector } from "react-redux";

import Stepper from "../../utils/components/Stepper";

const DetailImage = (props) => {
  let [state, setState] = useState({ chosenImg: "" });
  const configStorage = useSelector((store) => store.configStorage);
  const basketStorage = useSelector((store) => store.basketStorage);
  const { item, handleOnChange } = props || {};
  if (!item) return null;

  const renderSideImg = () => {
    const imageList = item.imageList;
    if (!imageList.includes(item.image)) {
      imageList.unshift(item.image);
    }
    if (imageList.length === 1 && item.image === imageList[0]) return null;
    return imageList.map((image, index) => {
      const src = configStorage.getImgUrl(image);
      return (
        <button key={"image" + index}
          className="col-6 col-md-3 col-lg-2 btn-link p-0"
          onClick={() => { setState({ chosenImg: src }); }}
        >
          <img
            className="small-image"
            src={src}
            alt={"Bild " + index}
          />
        </button >
      );
    });
  };

  return (
    <>
      <div className="col-12 col-md-6 col-lg-6 align-top d-flex flex-wrap">
        {renderSideImg()}
      </div>
      <div className="col-12 col-md-12 col-lg-12">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 pb-one">
            <img
              alt=""
              id="showcase"
              className="img-fluid"
              src={
                state.chosenImg === ""
                  ? configStorage.getImgUrl(item.image)
                  : state.chosenImg
              }
            />
          </div>
          <div className="nobleMetalsDetails col-12 col-md-6 col-lg-6">
            <div className="ser-itembox ser-grey">
              {item.text}
            </div >
            <div className="row ser-itembox">
              <div className="col-6">
                <span> Stückpreis: </span>
              </div>
              <div className="col-6 text-end">
                <span className="ser-grey"> {item.itemprice.toEuro()} </span>
              </div>
            </div>
            <div className="row ser-itembox">
              <div className="col-6">
                <span> MwSt.: </span>
              </div>
              <div className="col-6 text-end">
                <span className="ser-grey"> {item.tax.toEuro()} </span>
              </div>
            </div>
            <div className="row ser-itembox">
              <label className="col-6" htmlFor={"stk" + item.kennziffer}>
                <span>Stückzahl:</span>
              </label>
              <div className="col-6 text-end">
                <Stepper
                  id={"stk" + item.kennziffer}
                  label={"Stückzahl von " + item.name}
                  item={item}
                  disabled={basketStorage.locked}
                  onChange={handleOnChange}
                />
              </div>
            </div>
            <div className="row ser-itembox">
              <div className="col-6">
                <span className="ser-label ser-iblock"> Preis inkl. Steuer: </span>
              </div>
              <div className="col-6 text-end">
                <span className="ser-red"> {item.brutto.toEuro()} </span>
              </div>
              {configStorage.isKundenShop() || configStorage.isLightShop()
                ? <div className="col-12">
                  <span className="ser-label ser-iblock fs-6">
                    {configStorage.isLightShop()
                      ? "ggf. zuzüglich Versand- und Bearbeitungsgebühren"
                      : <>zzgl. {basketStorage.getShippingCosts().toEuro()} für Versand nach Hause</>
                    }
                  </span>
                </div>
                : null
              }
            </div>
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default DetailImage;
